import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ApplicationContext } from "@context/ApplicationContext";
import { SearchContext } from "@context/SearchContext";
import "./style.scss";

const Logo = ({ className, clickable = false, onNavigate }) => {
    const navigate = useNavigate();
    const { whiteLabel } = useContext(ApplicationContext);
    const { setSessions } = useContext(SearchContext);

    const handleNavigateHome = () => {
        setSessions([]);
        navigate("/");
    };

    const handleClick = onNavigate ?? handleNavigateHome;

    const logoImg = (
        <img
            src={whiteLabel?.logo_image_url}
            alt={whiteLabel?.brand_name || "Logo"}
            className="logo__img"
        />
    );

    return clickable ? (
        <a className={`logo__container ${className}`} onClick={handleClick} role="button">
            {logoImg}
        </a>
    ) : (
        <div className={`logo__container ${className}`}>
            {logoImg}
        </div>
    );
};

export default Logo;
